import { MyAccountPresenter } from "./MyAccountPresenter";
import { useAppSelector } from "redux/hooks";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";

export default function MyAccountContainer(): JSX.Element {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  return (
    <MyAccountPresenter
      accountId={selectedAccount.accountId}
    />
  );
}
